import React, { Component } from 'react'
import { Layout, Row, Col, Typography } from 'antd'
import { withTranslation } from 'react-i18next'
import { observer, inject } from 'mobx-react'
// import FileViewer from 'react-file-viewer'

import './printfilepreview.css'

const { Header, Content } = Layout
const { Text, Title } = Typography

@inject('printFileStore')
@observer
class PrintFilePreviewPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const printCode = this.props.match.params.printCode;
        this.props.printFileStore.getPrintFile(printCode);
    }

    render() {
        const { printCodeNotFound, isReading, remark, fileUrlList } = this.props.printFileStore;
        let index = 0;

        return (
            <Layout>
                <Header>
                    <Row>
                        <Col className='printfile-col-header'>
                            <Text className='printfile-text-header'>StayMenu - Print Preview</Text>
                        </Col>
                    </Row>
                </Header>
                <Content>
                    {isReading ? (
                        <Row>
                            <Col className='printfile-col-notfound'>
                                <Text className='printfile-text-notfound'>Reading print code ...</Text>
                            </Col>
                        </Row>
                    ) : (
                            <Row>
                                {printCodeNotFound ? (
                                    <Row>
                                        <Col className='printfile-col-notfound'>
                                            <Text className='printfile-text-notfound'>Print Code {this.props.match.params.printCode} is not found</Text>
                                        </Col>
                                    </Row>
                                ) : (
                                        <Row>
                                            <Col span={5} />
                                            <Col span={14} className='printfile-col-data-container'>
                                                <Title level={3}>File(s)</Title>
                                                {fileUrlList.map(url => {
                                                    if (url !== '') {
                                                        index = index + 1;
                                                        return (
                                                            <React.Fragment>
                                                                <Row>
                                                                    <Col className='printfile-col-data-file'>
                                                                        <a href={url}>File {index}</a>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        {/* <FileViewer
                                                                            fileType={url.split('.').pop()}
                                                                            filePath={url} /> */}
                                                                        {/* <iframe height="100%" width="100%"
                                                                            src="https://staymenu-images.s3.ap-east-1.amazonaws.com/Documents/1582070086709-RMS+Public+Interface+API+Documentation.pdf" /> */}
                                                                    </Col>
                                                                </Row>
                                                            </React.Fragment>
                                                        )
                                                    } else {
                                                        return null;
                                                    }
                                                })}
                                                <br />
                                                <hr />
                                                <Row>
                                                    <Title level={3}>Remark</Title>
                                                    <Col className='printfile-col-data-remark'>
                                                        <Text className='printfile-text-data-remark'>{remark}</Text>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col span={5} />
                                        </Row>
                                    )}
                            </Row>
                        )}
                </Content>
            </Layout>
        )
    }
}

export default withTranslation()(PrintFilePreviewPage)
